import React, { FC } from "react";

type DesktopLayoutProps = {
  children: [JSX.Element, JSX.Element, JSX.Element?];
  header: string;
};

const LEFT_SIDEBAR_CONTENT_INDEX = 0;
const MAIN_CONTENT_INDEX = 1;
const RIGHT_SIDEBAR_CONTENT_INDEX = 2;

const DesktopLayout: FC<DesktopLayoutProps> = ({ children, header }) => {
  return (
    <>
      {header && (
        <div className="container mt-7">
          <h3 class="mb-4 font-bold text-xl text-white/70">{header}</h3>
        </div>
      )}
      <div className="container grid grid-cols-12 gap-4 mt-7">
        <div className="col-span-3">{children[LEFT_SIDEBAR_CONTENT_INDEX]}</div>
        <div className="col-span-9">{children[MAIN_CONTENT_INDEX]}</div>
        {/* {children.length > 2 && (
        <div className="right-sidebar">
          {children[RIGHT_SIDEBAR_CONTENT_INDEX]}
        </div>
      )} */}
      </div>
    </>
  );
};

export default DesktopLayout;
